export const AUTHENTICATION_ROUTE_NAMES = {
    PAGE: "AuthenticationPage",
    LOGIN: "AuthenticationLogin",
};
